module.exports = __webpack_public_path__ + "img/221917_928380_5F504D_7C746C-256px.2229f878.png";